
import { Component, Prop, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/application";
const applicationState = namespace("Application");

import UnderlineForm from "@/components/utils/PopulateForms/components/UnderlineForm.vue";
import CheckBox from "@/components/utils/PopulateForms/components/CheckBox.vue";
import { nameInfoType } from "@/types/Application/CommonInformation";
import { yourInformationInfoDataInfoType } from '@/types/Application/CommonInformation/Pdf';
import { getYourInformationResults, getLocationInfo } from '@/components/utils/PopulateForms/PopulateCommonInformation';

@Component({
    components: {
        UnderlineForm,
        CheckBox
    }
})

export default class Form46Layout extends Vue {

    @Prop({ required: true })
    result!: any;

    @applicationState.State
    public applicantName!: nameInfoType;

    dataReady = false;

    yourInfo = {} as yourInformationInfoDataInfoType;

    existingFileNumber = '';
    dateOfAddressChange = '';
    otherPartyNames: string[] = [];
    acknowledge = false;

    mounted() {
        this.dataReady = false;
        this.extractInfo();
        this.dataReady = true;
    }

    public extractInfo() {
        this.yourInfo = this.getYourInfo();
        this.existingFileNumber = getLocationInfo(this.result.otherFormsFilingLocationSurvey);
        if (this.result.otherPartySurvey.otherPartyNamesDynamicPanel?.length > 0) {
            this.otherPartyNames = this.result.otherPartySurvey.otherPartyNamesDynamicPanel
                ?.map((namePanel) => `${namePanel?.name?.first ?? ''} ${namePanel?.name?.last ?? ''}`);
        }
        this.acknowledge = this.result.addressChangeNoticeSurvey?.acknowledgement?.length > 0;
    }

    public getYourInfo() {

        if (this.result?.addressChangeSurvey) {
            this.dateOfAddressChange = this.result?.addressChangeSurvey?.ChangeOfAddressDate
            return getYourInformationResults(this.result?.addressChangeSurvey);
        } else {
            return {} as yourInformationInfoDataInfoType;
        }

    }

}
